// extracted by mini-css-extract-plugin
export default {"alert-wrapper":"Alert_alert-wrapper__L8BIW","alert":"Alert_alert__NPrjL"};